import ReturnToHQ from 'components/hyperdrive/createTask/ReturnToHQ';
import React from 'react';

export default function ReturnToHQDrawer({closeModal}) {
  return (
    <ReturnToHQ closeModal={closeModal}/>
  );
}
